// extracted by mini-css-extract-plugin
export default {"backForm":"SubmittedFormMessage_backForm__eEhWx"};